import React from "react";
import { getActions, updateActionStatus } from "src/services/action.service";
import { Button, Stack, Box, Typography, Link } from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpIcon from '@mui/icons-material/Help';
import AddEditFileModal from "src/pages/AddEditFile.modal";
import config from "src/config";
import { ReactWebStore } from 'react-webstore';
import AddEditContainerModal from '../../modules/containers/AddEdit.modal';

const FileContainersAction = ({ action, onStatusClick, updating }) => {
    return (
        <div>
            <Stack direction="row" spacing={0.5}>
                <div>
                    {(action.confidence == 'high') ? (
                        <CheckCircleIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                    ) : null}
                    {(action.confidence == 'medium' || action.confidence == 'low') ? (
                        <AutoAwesomeIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                    ) : null}
                    {(!action?.confidence) ? (
                        <HelpIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                    ) : null}
                </div>
                <div>
                    <Typography variant="body1" color="textPrimary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.title}
                    </Typography>
                    {(action.confidence == 'high') ? (
                            <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                Associated with&nbsp;<b>{action?.containers.map((container) => container.name).join(', ')}</b>
                            </Typography>
                    ) : null}
                    {(action.confidence == 'medium') ? (
                            <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                I think this belongs to&nbsp;<b>{action?.containers.map((container) => container.name).join(', ')}</b>
                            </Typography>
                    ) : null}
                    {(action.confidence == 'low') ? (
                            <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                Not sure, but this might belong to&nbsp;<b>{action?.containers.map((container) => container.name).join(', ')}</b>
                            </Typography>
                    ) : null}
                    {(!action?.confidence) ? (
                            <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                I'm not sure where this belongs
                            </Typography>
                    ) : null}
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        divider={<Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.6, color: config.primaryColor, fontSize: '1.2rem', lineHeight: 0 }}>&middot;</Box>}
                    >
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('confirm')} disabled={updating}>
                            Confirm
                        </Button>
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('change')} disabled={updating}>
                            {(!action?.confidence) ? 'Choose' : 'Change'}
                        </Button>
                        {/* {(action.confidence == 'high') ? (
                            <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('undo')} disabled={updating}>
                                Undo
                            </Button>
                        ) : null} */}
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('clear')} disabled={updating}>
                            Skip
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    )
}

const WorkflowActionOrUpdate = ({ action, onStatusClick, updating }) => {
    return (
        <div>
            <Stack direction="row" spacing={0.5}>
                <div>
                    <HelpIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                </div>
                <div>
                    <Typography variant="body1" color="textPrimary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.text}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        divider={<Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.6, color: config.primaryColor, fontSize: '1.2rem', lineHeight: 0 }}>&middot;</Box>}
                    >
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('view')} disabled={updating}>
                            View
                        </Button>
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('clear')} disabled={updating}>
                            Dismiss
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    )
}

const ContainerUpdateAction = ({ action, onStatusClick, updating }) => {
    return (
        <div>
            <Stack direction="row" spacing={0.5}>
                <div>
                    <CheckCircleIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                </div>
                <div>
                    <Typography variant="body1" color="textPrimary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.text}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        divider={<Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.6, color: config.primaryColor, fontSize: '1.2rem', lineHeight: 0 }}>&middot;</Box>}
                    >
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('view')} disabled={updating}>
                            View
                        </Button>
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('clear')} disabled={updating}>
                            Dismiss
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    )
}

const FileUpdateAction = ({ action, onStatusClick, updating }) => {
    return (
        <div>
            <Stack direction="row" spacing={0.5}>
                <div>
                    <CheckCircleIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                </div>
                <div>
                    <Typography variant="body1" color="textPrimary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.text}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        divider={<Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.6, color: config.primaryColor, fontSize: '1.2rem', lineHeight: 0 }}>&middot;</Box>}
                    >
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('view')} disabled={updating}>
                            View
                        </Button>
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('clear')} disabled={updating}>
                            Dismiss
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    )
}

const CommentUpdateAction = ({ action, onStatusClick, updating }) => {

    // Parse @[Name](id) mentions in comment text and render them as clickable elements
	const renderMentions = (text) => {
		if (!text) {
			return text;
		}

		const mentionRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
		const parts = [];
		let lastIndex = 0;
		let match;

		while ((match = mentionRegex.exec(text)) !== null) {
			if (!match) break;

			const mentionName = match[1];
			const mentionId = match[2];

			// Add text before the mention
			if (match.index > lastIndex) {
				parts.push(text.slice(lastIndex, match.index));
			}
			// Add the mention element
			parts.push(
				<Link
					key={`mention-${mentionId}`}
					component="span"
					sx={{
						color: 'primary.main',
						textDecoration: 'none',
						fontWeight: 600,
						// cursor: 'pointer',
						// '&:hover': { textDecoration: 'underline' }
					}}
					// onClick={() => {
					// 	// Navigate to user profile or handle mention click
					// 	console.log('Mention clicked:', mentionId);
					// }}
				>
					&nbsp;@{mentionName}&nbsp;
				</Link>
			);
			lastIndex = mentionRegex.lastIndex;
		}

		// Add remaining text after last mention
		if (lastIndex < text.length) {
			parts.push(text.slice(lastIndex));
		}

		return parts;
	}

    return (
        <div>
            <Stack direction="row" spacing={0.5}>
                <div>
                    <CheckCircleIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
                </div>
                <div>
                    <Typography variant="body1" color="textPrimary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {renderMentions(action.title)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                        {action.text}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="center"
                        divider={<Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.6, color: config.primaryColor, fontSize: '1.2rem', lineHeight: 0 }}>&middot;</Box>}
                    >
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('view')} disabled={updating}>
                            View
                        </Button>
                        <Button variant="text" size="small" sx={{ padding: 0, minWidth: 'auto' }} onClick={() => onStatusClick('clear')} disabled={updating}>
                            Dismiss
                        </Button>
                    </Stack>
                </div>
            </Stack>
        </div>
    )
}

class Actions extends React.Component {
    constructor(props) {
        super(props);
        this.rws = new ReactWebStore();
        this.pollInterval = null;
        this.state = {
            loading: false,
            actions: [],
            isAddEditFileModalOpen: false,
            file_id: null,
            isAddEditContainerModalOpen: false,
            container_id: null,
            updating: false
        };
    }

    async setStateAsync(newState) {
        return new Promise((resolve) => {
            this.setState(newState, resolve);
        });
    }

    async componentDidMount() {
        await this.fetchActions();
        this.rws.subscribe('sync_actions', async (e) => {
            if (this.rws.getStore(e.type) == 'success') {
                if (this.state.actions.length > 0) {
                    this.stopPolling();
                    return;
                }
                this.fetchActions();
            }
        });
        if (this.state.actions.length === 0) {
            this.startPolling();
        }
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    startPolling() {
        if (this.pollInterval) return;
        this.pollInterval = setInterval(() => {
            this.fetchActions(false);
        }, 10000);
    }

    stopPolling() {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.actions !== this.state.actions) {
            if (this.props?.onExistsChange) {
                this.props.onExistsChange(this.state.actions.length > 0);
            }
        }
    }

    async fetchActions(showLoading = true) {
        try {

            // If modal is open, don't fetch actions to avoid closing the modal when user is interacting with it
            if (this.state.isAddEditFileModalOpen) {
                return;
            }

            if (showLoading) {
                this.setState({ loading: true });
            }
            let response = await getActions({status: 'pending'});
            const actions = response?.actions || [];
            this.setState({ actions });
            if (actions.length > 0) {
                this.stopPolling();
            }
        } catch (error) {
            console.error("Error fetching actions:", error);
        } finally {
            if (showLoading) {
                this.setState({ loading: false });
            }
        }
    }

    async onActionStatusClick(action, status) {
        try {
            this.setState({ updating: true });
            if (status === 'change' || status === 'view') {
                this.setState({ isAddEditFileModalOpen: true, file_id: action.file });
                await updateActionStatus(action._id, status);
                return;
            }
            await updateActionStatus(action._id, status);
            await this.fetchActions();
        } catch (error) {
            console.error("Error updating action status:", error);
        } finally {
            this.setState({ updating: false });
        }
    }

    async onContainerUpdateStatusClick(action, status) {
        try {
            this.setState({ updating: true });
            if (status === 'view') {
                this.setState({ isAddEditContainerModalOpen: true, container_id: action?.containers?.[0] });
                await updateActionStatus(action._id, status);
                return;
            }
            await updateActionStatus(action._id, status);
            await this.fetchActions();
        } catch (error) {
            console.error("Error updating action status:", error);
        } finally {
            this.setState({ updating: false });
        }
    }

    async onFileUpdateStatusClick(action, status) {
        try {
            this.setState({ updating: true });
            if (status === 'view') {
                this.setState({ isAddEditFileModalOpen: true, file_id: action.file });
                await updateActionStatus(action._id, status);
                return;
            }
            await updateActionStatus(action._id, status);
            await this.fetchActions();
        } catch (error) {
            console.error("Error updating action status:", error);
        } finally {
            this.setState({ updating: false });
        }
    }

    async onCommentUpdateStatusClick(action, status) {
        try {
            this.setState({ updating: true });
            if (status === 'view') {
                if ('file' in action && action?.file) {
                    this.setState({ isAddEditFileModalOpen: true, file_id: action.file, isOpenComment: true });
                    await updateActionStatus(action._id, status);
                    return;
                } else if ('containers' in action && action?.containers?.length > 0) {
                    this.setState({ isAddEditContainerModalOpen: true, container_id: action?.containers?.[0], isOpenComment: true });
                    await updateActionStatus(action._id, status);
                    return;
                }
            }
            await updateActionStatus(action._id, status);
            await this.fetchActions();
        } catch (error) {
            console.error("Error updating action status:", error);
        } finally {
            this.setState({ updating: false });
        }
    }

    render() {
        

        if (this.state.loading) {
            return (
                <Stack direction="row" spacing={1} alignItems="center" sx={{ opacity: 0.8 }}>
                    <Typography variant="subtitle2" color={'textSecondary'} sx={{ display: 'flex', alignItems: 'center', opacity: 0.4 }}>
                        Loading actions...
                    </Typography>
                </Stack>
            );
        }

        const { actions } = this.state;

        if (!actions || actions.length === 0) {
            return null;
        }
        
        return (
            <Stack direction="row" spacing={1} alignItems="center" sx={{ opacity: 0.8 }}>
                {actions.map((action) => {
                    switch (action.type) {
                        case 'file_containers':
                            return (<FileContainersAction key={action._id} action={action} updating={this.state.updating} onStatusClick={(status) => this.onActionStatusClick(action, status)} />);
                        case 'workflow_action':
                        case 'workflow_update':
                            return (<WorkflowActionOrUpdate key={action._id} action={action} updating={this.state.updating} onStatusClick={(status) => this.onActionStatusClick(action, status)} />);
                        case 'container_update':
                            return (<ContainerUpdateAction key={action._id} action={action} updating={this.state.updating} onStatusClick={(status) => this.onContainerUpdateStatusClick(action, status)} />);
                        case 'file_update':
                            return (<FileUpdateAction key={action._id} action={action} updating={this.state.updating} onStatusClick={(status) => this.onFileUpdateStatusClick(action, status)} />);
                        case 'comment_update':
                            return (<CommentUpdateAction key={action._id} action={action} updating={this.state.updating} onStatusClick={(status) => this.onCommentUpdateStatusClick(action, status)} />);
                        default:
                            return null;
                    }
                })}

                {(this.state.isAddEditFileModalOpen && this.state.file_id) ? (
                    <AddEditFileModal
                        open={this.state.isAddEditFileModalOpen}
                        openComment={this.state.isOpenComment}
                        file={{ _id: this.state.file_id }}
                        onClose={async () => {
                            await this.setStateAsync({isAddEditFileModalOpen: false, isOpenComment: false});
                            this.fetchActions();
                        }}
                        onSave={async () => {
                            await this.setStateAsync({isAddEditFileModalOpen: false, isOpenComment: false});
                            this.fetchActions();
                        }}
                    />
                ) : null}

                {(this.state.isAddEditContainerModalOpen && this.state.container_id) ? (
                    <AddEditContainerModal
                        open={this.state.isAddEditContainerModalOpen}
                        openComment={this.state.isOpenComment}
                        onClose={async () => {
                            await this.setStateAsync({isAddEditContainerModalOpen: false, container_id: null, isOpenComment: false});
                            this.fetchActions();
                        }}
                        container={this.state?.container_id}
                        onSave={async () => {
                            await this.setStateAsync({isAddEditContainerModalOpen: false, container_id: null, isOpenComment: false});
                            this.fetchActions();
                        }}
                    />
                ) : null}

            </Stack>
        );
    }
}

export default Actions;
